import script from "./page-test.vue?vue&type=script&setup=true&lang=js"
export * from "./page-test.vue?vue&type=script&setup=true&lang=js"

import "./page-test.vue?vue&type=style&index=0&id=1a809c92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a809c92"]])

export default __exports__